import {Component, OnInit} from '@angular/core';
import {NavbarService} from "../service/navbar.service";

@Component({
  selector: '[id="twitter-authorization-success-wrapper"][style="width:100%"]',
  templateUrl: './beta/authentication/twitter-success.component.html',
  styleUrls: ['./twitter-authorization-confirmation.component.scss']
})
export class TwitterAuthorizationConfirmationComponent implements OnInit {
  public currentYear: number;

  constructor(public nav: NavbarService) {

  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    setTimeout(() => {
      this.nav.hide();
    }, 0);
  }

}
